document.addEventListener('DOMContentLoaded', function() {
	console.log('init hair v3');

	const maxVelocity = 10;
	const mouseForce = 0.5;

	const containerClassname = 'front-banner';
	let containerEl = document.getElementsByClassName(containerClassname)[0];

	function setupCanvas(canvas, conteiner) {
		const dpr = window.devicePixelRatio || 1;
		const rect = conteiner.getBoundingClientRect();
		canvas.width = rect.width * dpr;
		canvas.height = rect.height * dpr;
		let ctx = canvas.getContext('2d');
		ctx.scale(dpr, dpr);

		console.log(`dpr ${dpr}`);

		return ctx;
	}

	let canvas = document.createElement('canvas');
	canvas.style.position = 'absolute';
	canvas.style.width = '100%';
	canvas.style.top = 0;
	canvas.style.left = 0;
	canvas.style.overflow = 'hidden';
	canvas.style['z-index'] = -100;

	containerEl.appendChild(canvas);

	let ctx = setupCanvas(canvas, containerEl);
	let w = canvas.width;
	let h = canvas.height;
	let mouse = [w / 2, h / 2];

	const force = 60;

	class Ball {
		constructor(pos, vel, r, anchorPos, ropeLen, dumping) {
			this.pos = pos.slice(0);
			this.vel = vel.slice(0);
			this.r = r;
			this.anchorPos = anchorPos.slice(0);
			this.ropeLen = ropeLen;
			this.dumping = dumping;
		}

		fixRope() {
			let x = this.pos[0] - this.anchorPos[0];
			let y = this.pos[1] - this.anchorPos[1];
			const r = Math.sqrt(x * x + y * y);

			if (r > this.ropeLen) {
				x /= r;
				y /= r;
				this.pos[0] = (this.pos[0] + this.anchorPos[0] + x * this.ropeLen) / 2;
				this.pos[1] = (this.pos[1] + this.anchorPos[1] + y * this.ropeLen) / 2;
				this.vel[0] -= x * (r - this.ropeLen) * this.dumping;
				this.vel[1] -= y * (r - this.ropeLen) * this.dumping;
			}
		}

		update() {
			const xv = this.pos[0];
			const yv = this.pos[1];
			let r = Math.sqrt(xv * xv + yv * yv);

			if (r < 10) {
				r = 10;
			}

			this.vel[0] += (xv * force) / r / r;
			this.vel[1] += (yv * force) / r / r;

			this.vel[1] += 0.1;

			if (mouse[0] > this.pos[0]) {
				this.vel[0] -= mouseForce;
			} else {
				this.vel[0] += mouseForce;
			}

			if (mouse[1] > this.pos[1]) {
				this.vel[1] += mouseForce / 2;
			}

			// clamp velocity
			if (this.vel[0] > maxVelocity) {
				this.vel[0] = maxVelocity;
			}

			if (this.vel[0] < -maxVelocity) {
				this.vel[0] = -maxVelocity;
			}

			if (this.vel[1] > maxVelocity) {
				this.vel[1] = maxVelocity;
			}

			if (this.vel[1] < -maxVelocity) {
				this.vel[1] = -maxVelocity;
			}

			this.fixRope();

			const y = this.pos[1] + this.vel[1];

			if (y < -h / 12) {
				this.vel[1] *= -1;
			}

			this.pos[0] += this.vel[0];
			this.pos[1] += this.vel[1];
		}

		render() {
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = '#000';
			ctx.beginPath();
			ctx.moveTo(this.pos[0], this.pos[1]);
			ctx.quadraticCurveTo(
				this.anchorPos[0],
				(this.anchorPos[1] + this.pos[1]) / 2,
				this.anchorPos[0],
				this.anchorPos[1]
			);
			ctx.stroke();
		}
	}

	let balls = [];
	let ballCount = 180;
	let isMobile = false;
	let baseLength = h / 3;

	if (w / h < 1.5) {
		isMobile = true;
	}

	if (isMobile) {
		ballCount = 90;
		baseLength = h / 5;
	}

	console.log(`3/2 aspect? ${isMobile}`);
	console.log(`baseLength ${baseLength}`);
	console.log(`w ${w}, h ${h}`);

	for (let i = 0; i < ballCount; i++) {
		balls.push(
			new Ball(
				[0, h / 2], // pos
				[0, 10], // vel
				h / 10, // r
				[Math.random() * w, -20], // anchorPos
				baseLength + Math.random() * (h * 0.1), // ropeLen
				0.99 // dumping
			)
		);
	}

	function loop() {
		requestAnimationFrame(loop);

		ctx.fillStyle = '#ffffff';
		// ctx.fillStyle = 'rgba(255, 255, 255, 0.09)';
		ctx.fillRect(0, 0, w, h);

		// for feedback
		// ctx.beginPath();
		// ctx.arc(mouse[0], mouse[1], 10, 0, Math.PI * 2, 0);
		// ctx.fillStyle = 'rgba(0, 0, 255, 1)';
		// ctx.fill();

		for(var i = 0; i < balls.length; i++){
			balls[i].update();
			balls[i].render();
		}
	}

	loop();

	window.addEventListener('resize', function() {
		setupCanvas(canvas, containerEl);
	});

	window.addEventListener('mousemove', function(e) {
		mouse[0] = e.clientX;
		mouse[1] = e.clientY;
	});
});



// WEBPACK FOOTER //
// ./scripts/plugins/hair.js